import { createActionGroup, emptyProps } from "@ngrx/store";

export const SignInWithUsernameActions = createActionGroup({
	source: "Sign In With Username Page",
	events: {
		"Get Latest App Version": emptyProps(),
	},
});
